import Vue from "vue"
import VueRouter from "vue-router"

import layout from "@/layout"
Vue.use(VueRouter)

const routes = [

	{
		path: '/',
		name: 'student',
		component: layout,
		redirect: "/main",
		children: [
      {
				path: '/main',
				name: '首页',
				meta: {
					title: '首页',
          isNavbar: true,
				},
				component: () => import('@/views/main.vue'),
			},
			{
				path: '/policy',
				redirect: '/policy/index',
				meta: {
					title: '政策资讯',
					requiresAuth: true,
          isNavbar: true,
				},
				component: () => import('@/views/router-view.vue'),
				children: [
					{
						path: 'index',
            name: 'PolicyIndex',
						meta: {
							title: '政策资讯',
					    keepAlive: true,
							requiresAuth: true,
						},
						component: () => import('@/views/policy.vue')
					},
          {
						path: 'details',
						meta: {
							title: '政策资讯',
							requiresAuth: true,
						},
						component: () => import('@/views/details.vue')
					},
				]
			},
			{
				path: '/speciality',
				name: '专业解读',
				redirect: '/speciality/majors',
				meta: {
					title: '专业解读',
					requiresAuth: true,
          isNavbar: true,
				},
				component: () => import('@/views/router-view.vue'),
				children: [
					{
						path: 'majors',
						meta: {
							title: '专业解读',
							requiresAuth: true,
						},
						component: () => import('@/views/speciality/majors/index.vue')
					},
					{
						path: 'majorsDetail',
						meta: {
							title: '专业解读',
							requiresAuth: true,
						},
						component: () => import('@/views/speciality/majorsDetail/index.vue')
					},
					{
						path: 'diff',
						meta: {
							title: '专业对比',
							requiresAuth: true,
						},
						component: () => import('@/views/speciality/diff/index.vue')
					},
				]
			},
      {
				path: '/schoolQuery',
				name: 'schoolQuery',
				meta: {
					title: '院校查询',
          requiresAuth: true,
          isNavbar: true,
          gaokaoLimit: true,
				},
				component: () => import('@/views/studentEdition/schoolQuery/index.vue')
			},
      {
        path: '/establishArchives',
        meta: {
          title: '建立档案',
          requiresAuth: true,
          // isNavbar: true,
        },
        component: () => import('@/views/studentEdition/establishArchives/index.vue')
      },
      {
        name: 'previewArchives',
        path: '/previewArchives',
        meta: {
          title: '档案预览',
        },
        component: () => import('@/views/studentEdition/establishArchives/previewArchives.vue')
      },
      {
        path: '/positionProfession',
        meta: {
          title: '定位专业',
          requiresAuth: true,
          isNavbar: true,
          gaokaoLimit: true,
        },
        component: () => import('@/views/studentEdition/positionProfession/index.vue')
      },
      {
        name: 'previewProfession',
        path: '/previewProfession',
        meta: {
          title: '定位专业预览',
        },
        component: () => import('@/views/studentEdition/positionProfession/previewProfession.vue')
      },
      {
        name: 'downAndPrint',
        path: '/downAndPrint',
        meta: {
          title: '方案下载',
        },
        component: () => import('@/views/studentEdition/downAndPrint/index.vue')
      },
      {
        name: 'singlePrint',
        path: '/singlePrint',
        meta: {
          title: '方案下载',
        },
        component: () => import('@/views/studentEdition/downAndPrint/singlePrint.vue')
      },
      {
        path: '/schemeDesign',
        meta: {
          title: '设计方案',
          requiresAuth: true,
          isNavbar: true,
          gaokaoLimit: true,
        },
        component: () => import('@/views/studentEdition/schemeDesign/management.vue')
      },
      {
        name: 'schemePreview',
        path: '/schemePreview',
        meta: {
          title: '预览',
        },
        component: () => import('@/views/studentEdition/schemePreview/index.vue')
      },
      {
        path: '/schemeMake',
        meta: {
          title: '方案制作',
        },
        component: () => import('@/views/studentEdition/schemeMake/index.vue')
      },
      {
				path: '/school',
				name: 'school',
				meta: {
					title: '院校解读'
				},
				component: () => import('@/views/school/detail/index.vue')
			},
			{
				path: '/schoolDiff',
				name: 'schoolDiff',
				meta: {
					title: '院校对比'
				},
				component: () => import('@/views/school/diff/index.vue')
			},
      {
        path: '/autoGenerate',
        meta: {
          title: '智慧生成',
          requiresAuth: true,
        },
        component: () => import('@/views/studentEdition/autoGenerate/index.vue')
      },
      {
        path: '/collegeSubject',
        redirect: '/collegeSubject/center',
        meta: {
          title: '高考选科',
          requiresAuth: true,
          isNavbar: true,
        },
        component: () => import('@/views/router-view.vue'),
        children: [
          {
            path: 'center',
            meta: {
              title: '高考选科',
              requiresAuth: true,
            },
            component: () => import('@/views/collegeSubject/index.vue')
          },
        ]
      },
      {
        path: '/tutorialStu',
        name: 'tutorialStu',
        meta: {
          title: '操作教程',
          requiresAuth: false,
          isNavbar: true,
          reqType: '1',
          reqIsLogin: '1',
        },
        component: () => import('@/views/tutorial.vue')
      },
      {
        path: '/myFile',
        name: 'myFile',
        meta: {
          title: '我的档案',
          requiresAuth: false,
          isNavbar: true
        },
        component: () => import('@/views/myFile.vue')
      },
      // {
      //   path: '/downAndPrint',
      //   meta: {
      //     title: '下载打印',
      //     requiresAuth: true,
      //     isNavbar: true,
      //   },
      //   component: () => import('@/views/studentEdition/downAndPrint/myFile.vue')
      // },
      // {
			// 	path: '/aiQA',
			// 	name: 'AI 问答',
			// 	meta: {
			// 		title: 'AI 问答',
			// 		requiresAuth: true,
      //     isNavbar: true,
      //     hideFooter: true,
			// 	},
			// 	show: false,
			// 	component: () => import('@/views/aiQA.vue')
			// },
		]
	},
]

export default routes
